import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import NotificationHistoryCard from '../../components/NotificationHistoryCard';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';
import RoleNotificationPrefsCard from '../../components/RoleNotificationPrefsCard';
import { fetchAccountSettings, fetchNotificationHistory, updateAccountNotifications } from '../../utils/accountSettingsApi';

export default function HostNotificationsPage() {
  const [notifications, setNotifications] = useState({});
  const [prefsConfig, setPrefsConfig] = useState({});
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [settings, historyItems] = await Promise.all([
          fetchAccountSettings(),
          fetchNotificationHistory({ scope: 'account' }),
        ]);
        setNotifications(settings.notifications || {});
        setPrefsConfig(settings.notification_prefs_config || {});
        setHistory(historyItems || []);
      } catch (err) {
        toast.error('Failed to load notification settings');
      }
    };
    load();
  }, []);

  const persist = async (next, previous) => {
    setNotifications(next);
    try {
      await updateAccountNotifications(next);
    } catch (err) {
      setNotifications(previous);
      toast.error(err.response?.data?.detail || 'Failed to update notifications');
    }
  };

  const handleToggle = (key) => {
    const current = notifications[key] !== false;
    const next = { ...notifications, [key]: !current };
    persist(next, notifications);
  };

  return (
    <HostSettingsLayout title="Notifications & History" dataTestId="host-notifications-page">
      <RoleNotificationPrefsCard
        role="host"
        config={prefsConfig}
        notifications={notifications}
        onToggle={handleToggle}
        testIdPrefix="host-notifications-prefs"
      />

      <NotificationHistoryCard notifications={history} dataTestIdPrefix="host-notifications-history" />
    </HostSettingsLayout>
  );
}
